import React, { useRef, useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Paper,
  Box,
  Button,
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

function GRNs({ onCheckboxSelection }) {
  const [selected, setSelected] = useState(null);

  // Handle checkbox selection
  const handleCheckboxClick = (id) => {
    setSelected(id);
    onCheckboxSelection(true); // Notify parent that a checkbox is selected
  };

  // Static data for the GRNs table
  const grns = [
    {
      id: 1,
      poId: 'PO-001',
      grnId: 'GRN-001',
      name: 'GRN 1',
      transDate: '2023-10-01',
      status: 'Success',
    },
    {
      id: 2,
      poId: 'PO-002',
      grnId: 'GRN-002',
      name: 'GRN 2',
      transDate: '2023-10-02',
      status: 'Fail',
    },
    {
      id: 3,
      poId: 'PO-003',
      grnId: 'GRN-003',
      name: 'GRN 3',
      transDate: '2023-10-03',
      status: 'Success',
    },
  ];
  const fileInputRef = useRef(null);

  const handleUploadClick = () => {
   fileInputRef.current.click();
 };

  const handleFileChange = (event) => {
   const file = event.target.files[0];
   if (file) {
     console.log('Selected file:', file);
     // You can add your file handling logic here (e.g., upload to a server)
   }
 };

 return (
   <TableContainer component={Paper}>
     <Box sx={{ padding: '16px', display: 'flex', justifyContent: 'flex-end' }}>
       <Button variant="contained" startIcon={<CloudUploadIcon />} onClick={handleUploadClick}>
         Upload
       </Button>
       <input
       type="file"
       ref={fileInputRef}
       style={{ display: 'none' }}
       onChange={handleFileChange}
     />
     </Box>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell  sx={{ fontWeight: 'bold', fontSize: '1rem' }}>Select</TableCell>
            <TableCell  sx={{ fontWeight: 'bold', fontSize: '1rem' }}>S.No</TableCell>
            <TableCell  sx={{ fontWeight: 'bold', fontSize: '1rem' }}>PO ID</TableCell>
            <TableCell  sx={{ fontWeight: 'bold', fontSize: '1rem' }}>GRN ID</TableCell>
            <TableCell  sx={{ fontWeight: 'bold', fontSize: '1rem' }}>Name</TableCell>
            <TableCell  sx={{ fontWeight: 'bold', fontSize: '1rem' }}>Trans Date</TableCell>
            <TableCell  sx={{ fontWeight: 'bold', fontSize: '1rem' }}>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {grns.map((grn) => (
            <TableRow key={grn.id}>
              <TableCell>
                <Checkbox
                  checked={selected === grn.id}
                  onChange={() => handleCheckboxClick(grn.id)}
                />
              </TableCell>
              <TableCell>{grn.id}</TableCell>
              <TableCell>{grn.poId}</TableCell>
              <TableCell>{grn.grnId}</TableCell>
              <TableCell>{grn.name}</TableCell>
              <TableCell>{grn.transDate}</TableCell>
              <TableCell>{grn.status}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default GRNs;